import { useQueryClient } from "@tanstack/react-query";

import { ReviewItemFieldsFragment, useEditReportCommentMutation } from "@api/graphql/types-and-hooks";
import { invalidateReviewItems, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { notifyError } from "@components/notifications/notifications";

export const useEditComment = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useEditReportCommentMutation({
    onSuccess: async (data) => {
      if (settleReviewMutation(data?.editReportComment, { failure: "Failed to edit comment" })) {
        await invalidateReviewItems(queryClient);
      }
    },
    onError: () => notifyError("Error editing comment. Please try again."),
  });

  const edit = (comment: ReviewItemFieldsFragment, body: string, onSaved: () => void) =>
    mutate(
      { id: comment.id, body },
      {
        onSuccess: (data) => {
          if (data?.editReportComment?.success) onSaved();
        },
      },
    );

  return { edit, isPending };
};
